import React from "react";
import TimePicker from 'rc-time-picker';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
const TimePickerControl = ({ value, ...props }) => {
  
    const val = typeof value === 'object' ? value : null;

    return (
        <div style={{ width: '100%', position: 'relative',display:'flex' }}>
            <TimePicker value={val} {...props} style={{ width: '100%' }} showSecond={false} focusOnOpen={true} inputIcon={<FontAwesomeIcon
                style={{ position: 'absolute', right: '20px', top: '5px' }}  icon={faClock} onClick={props.onClick} />
            } />
        </div>
    );
};

export default TimePickerControl;

